
const PromotionsTag = ({
	children,
}) => {
	return <div className='vs--promotions-tag'>
		{children}
	</div>

}

export default PromotionsTag